import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="white" />
      <path d="M6 18V6L11.5 11.5H9V18H6Z" fill="#1C1B25" />
      <path d="M18.1001 6V18L12.6001 12.5H15.1001V6H18.1001Z" fill="#1C1B25" />
    </Svg>
  );
};

export default Icon;
